import axios from "../../app/common/libs/http";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTotalStats = createAsyncThunk(
    "dashboard/getTotalStats", async ({ startDate, endDate, campaignId }) => await axios.post(`${process.env.REACT_APP_APIURL}/insights/dashboardStats`, {
        "from": startDate,
        "to": endDate,
        "campaignId": campaignId
    })
);
export const fetchRecentTranscripts = createAsyncThunk(
    "dashboard/getRecentTranscripts", async ({ startDate, endDate, campaignId }) => await axios.post(`${process.env.REACT_APP_APIURL}/insights/recentTranscripts`, {
        "from": startDate,
        "to": endDate,
        "campaignId" : campaignId
    })
);

export const fetchConversationRating = createAsyncThunk(
    "transcripts/getConversationRating", async (conversationSid) => await axios.get(`${process.env.REACT_APP_APIURL}/conversation/getRating/${conversationSid}`, { conversationSid: conversationSid})
  );
export const fetchOnlineAgents = createAsyncThunk(
    "dashboard/onlineAgents", async (campaignId) => await axios.post(`${process.env.REACT_APP_APIURL}/user/getFlecxOnlineAgents/` + campaignId)
);
export const forceAwayAgent = createAsyncThunk(
    "dashboard/forceAwayAgent",
    async (userId, { rejectWithValue }) => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_APIURL}/user/forceAwayAgent/${userId}` , {userId:userId});
        return response.data;
      } catch (err) {
        return rejectWithValue(err.response.data)
      }
    }
  );
export const fetchCampaigns = createAsyncThunk(
    "dashboard/fetchCampaigns", async () => await axios.get(`${process.env.REACT_APP_APIURL}/campaign/getCampaignSelect`)
);

export const isConversationPending = createAsyncThunk(
    "dashboard/isConversationPending", async (userId) => await axios.get(`${process.env.REACT_APP_APIURL}/user/isConversationPending/${userId}`)
);